<script>
    import { createEventDispatcher } from 'svelte';
    import { badgesFor } from './auraBadges.js';
    import BadgeRow from './BadgeRow.svelte';
    import GameText from './GameText.svelte';

    export let entry;
    export let view = 'grid';
    export let groupedBy = null;
    export let searching = false;

    const dispatch = createEventDispatcher();

    $: aura = entry;
    $: badges = badgesFor(aura);

    // Three of the 33 published auras sit in two effect groups. The first carries the card's
    // identity colour; both are still listed as pills.
    $: effectGroups = aura.effectGroups || [];
    $: primaryEffect = effectGroups.length > 0 ? effectGroups[0].key : 'none';

    // Cards view drops the prose for density, but the search index covers it, so a hit
    // would otherwise show a card with nothing on it explaining the match.
    $: showDescription = (view === 'list' || searching) && aura.description;

    $: showEffectPills = groupedBy !== 'effect';

    function selectSource(category) {
        dispatch('selectFacet', { id: 'source', value: category });
    }

    function selectEffect(label) {
        dispatch('selectFacet', { id: 'effect', value: label });
    }
</script>

<div
    class="guide-card effect-{primaryEffect}"
    class:guide-card--compact={view !== 'list'}>
    <span class="guide-card-bar" aria-hidden="true"></span>
    <div class="guide-card-body">
        <div class="guide-card-head">
            <a
                class="guide-card-name guide-card-link"
                href={`/guides/auras/${aura.slug}`}
                title={aura.description || aura.displayName}>{aura.displayName}</a>
            {#each aura.sourceCategories || [] as category}
                <button
                    type="button"
                    class="guide-category-pill guide-category-pill--{category.toLowerCase()}"
                    on:click={() => selectSource(category)}>
                    {category}
                </button>
            {/each}
            {#if showEffectPills}
                {#each effectGroups as group}
                    <button
                        type="button"
                        class="guide-accent-pill guide-accent-pill--button effect-{group.key}"
                        on:click={() => selectEffect(group.label)}>
                        {group.label}
                    </button>
                {/each}
            {/if}
        </div>

        {#if showDescription}
            <span class="guide-card-snippet">{aura.description}</span>
        {/if}

        <BadgeRow {badges} {view} on:selectFacet />

        {#if aura.tags && aura.tags.length > 0}
            <span class="guide-card-tags">
                {#each aura.tags as tag}
                    <button
                        type="button"
                        class="guide-tag-pill"
                        on:click={() => dispatch('selectFacet', { id: 'tag', value: tag })}>
                        <GameText text={tag} />
                    </button>
                {/each}
            </span>
        {/if}
    </div>
</div>
